import React from 'react';
import { useDispatch } from 'react-redux';

import { H3, Modal, ModalCloseProps, SimpleCallback, Text } from 'platform-components';
import { CloseButton } from 'platform-components/src/components/close-button/_view/close-button_view_outer';

import * as classActions from 'common.components/classes/actions';

import { ClassNameEditor } from '../__name-editor/class__name-editor';

import './class__name-editor-modal.scss';

interface Props {
    teamId: number;
    teamGrade?: number | null;
    onClose: SimpleCallback;
    opened: boolean;
}

export const ClassNameEditorModal = ({ teamId, teamGrade, onClose, opened }: Props) => {
    const dispatch = useDispatch();

    if (!opened) {
        return null;
    }

    const save = (data: { letter: string; number: number }) => {
        const { letter, number } = data;
        dispatch(classActions.setNameRequest(teamId, letter, number));
    };

    return (
        <Modal
            //@ts-ignore - EDUCATION-37077: [react-update]: fixme typings: Хочет ReactNode вместo JSX.Element
            Close={(closeProps: ModalCloseProps) => (
                <CloseButton {...closeProps} position={CloseButton.POSITION.ABSOLUTE} />
            )}
            hasClose
            mix="class-name-editor-modal"
            onRequestClose={onClose}
            opened={true}
            theme={Modal.THEMES.TEACHER}
        >
            <Modal.Header>
                <H3 id="class.nameEditorModal.title" values={{ level: teamGrade }} weight={Text.WEIGHT.M} />
            </Modal.Header>
            <Modal.Content>
                <div className="class-name-editor-modal__sub-title">
                    <Text id="class.nameEditorModal.subTitle" size={Text.SIZE.XL} values={{ level: teamGrade }} />
                </div>
            </Modal.Content>
            <ClassNameEditor onRequestSave={save} />
        </Modal>
    );
};
